
module.exports.DesktopRenderingMode = "desktop";
module.exports.TabletRenderingMode = "tablet";
module.exports.TVRenderingMode = "tv";

module.exports.BrowserShellType = "browser";
module.exports.WindowsShellType = "windows";
module.exports.AndroidShellType = "android";
module.exports.IOSShellType = "iOS";

